<div class="global-subheader d-flex align-center" *ngIf="pageTitle">
  <button class="global-subheader-back" type="button" *ngIf="showBackButton" (click)="goBack()">
    <app-svg-icon src="assets/icons/arrow-left.svg" width="12px" height="12px"></app-svg-icon>
    Voltar
  </button>
  <span class="global-subheader-separator" aria-hidden="true"></span>
  <h1 class="global-subheader-title" [class.global-subheader-title--override]="titleOverride && !titleOverride.plainTitle">
    <ng-container *ngIf="breadcrumbSource">
      <span class="global-subheader-breadcrumb">{{ breadcrumbSource }}</span>
      <span class="global-subheader-breadcrumb-sep" aria-hidden="true">›</span>
    </ng-container>
    {{ displayTitle }}
  </h1>
  <app-status-badge
    *ngIf="titleOverride?.badgeLabel"
    [label]="titleOverride!.badgeLabel!"
    [tone]="badgeTone"
    variant="outline">
  </app-status-badge>

  <app-kpi-row
    *ngIf="kpis.length"
    class="global-subheader-kpis"
    [items]="kpis"
    layout="inline-pills">
  </app-kpi-row>
</div>
